import { UAParser } from 'ua-parser-js';
import { Component } from '@angular/core';
import { WizardPageComponent } from '../../../../core/wizard/wizard-page-component';
import type { WelcomeWizard } from '../welcome-wizard';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { HitTrackingService } from '../../../../core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { UserPreferencesService } from 'src/app/core/user-preferences/user-preferences.service';
import { map } from 'rxjs/operators';


@Component({
  standalone: false,
  selector: 'mtn-welcome-wizard-start-page',
  templateUrl: './welcome-wizard-start-page.component.html',
  styleUrls: ['./welcome-wizard-start-page.component.scss']
})
export class WelcomeWizardStartPageComponent extends WizardPageComponent<WelcomeWizard> {

  key = 'start';

  constructor(
    private hitTrackingService: HitTrackingService,
    private userPreferencesService: UserPreferencesService
  ) {
    super();
    this.title = `Welcome! Let's get started.`;
    this.stepperText = 'Start';
    this.closeButtonText = 'Close';
    this.doNotShowAgainCheckbox = `Don't show again`;
    this.headerText = 'First Time Setup';
    this.nextButtonText = 'Next';
    this.subheaderText = `Welcome to Insights! We're glad you're here, and we're ready to start helping you get at the data you need. But first, we need to ask you a few questions so we can tailor Insights to your needs.`;
  }

  onClose(): Observable<null> {
    if (this.wizard.doNotShowAgainCheckboxChecked) {
      const request = _.cloneDeep(this.wizard.model.userPreferences);
      request.isWelcomeWizardComplete = true;
      this.userPreferencesService.updateOne(request)
        .pipe(map(() => null));
    }
    const meta = this.buildTrackingMeta();

    // 🔹 Track Close
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_SETUP,
      meta,
      USER_TRACKING_ACTIONS.CLOSE,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.CLOSE],
      false
    ).subscribe();
    return super.onClose();
  }

  onDonotShowAgainClick(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_SETUP,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_OUT,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_OUT],
      false
    ).subscribe();
  }

  onDonotShowAgainUnchecked(): any {
    const parser = new UAParser(navigator.userAgent).getResult();
    let deviceType = parser.device.type;
    if (!deviceType) {
      deviceType = 'desktop';
    }
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_SETUP,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.OPT_IN_WELCOME,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPT_IN_WELCOME],
      false
    ).subscribe();
  }

  onNext(): Observable<string> {
    const meta = this.buildTrackingMeta();
    const OSmetadata = this.hitTrackingService.getFirstTimeSetupMetadata();

    // 🔹 Track Next
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.FIRST_TIME_SETUP,
      { ...meta, ...OSmetadata },
      USER_TRACKING_ACTIONS.NEXT,
      USER_TRACKING_ACTION_DESCRIPTIONS.USER_TRACKING_ACTIONS_NEXT_START,
      false
    ).subscribe();

    return of('volume');
  }

  private buildTrackingMeta(): any {
    return {
      time: new Date().toISOString()
    };
  }
}
